export const locale = {
    lang: 'tr',
    data: {
        'MODULE': {
            'TITLE': 'Merhaba Dünya!'
        }
    }
};



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/modules/i18n/tr.ts